import { render, staticRenderFns } from "./InformationTable.vue?vue&type=template&id=017cfe16"
import script from "./InformationTable.vue?vue&type=script&lang=js"
export * from "./InformationTable.vue?vue&type=script&lang=js"
import style0 from "./InformationTable.vue?vue&type=style&index=0&id=017cfe16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports